<template>
  <v-app id="app">
    <Header
      :user="user"
      :page-name="pageName"
      @showSidebar="sidebar = true"
    />
    <Sidebar v-model="sidebar" />
    <v-main :key="key">
      <router-view
        v-if="show"
        @pageName="setPageName"
      />
    </v-main>
  </v-app>
</template>

<script>
import Header from '@/components/organisms/Header'
import Sidebar from '@/components/organisms/Sidebar'

export default {
  name: 'App',
  components: {
    Header,
    Sidebar
  },
  data () {
    return {
      sidebar: false,
      show: false,
      key: Date.now(),
      pageName: null
    }
  },
  computed: {
    user () {
      console.debug(this.$store.state.Auth.user || this.$store.state.Auth.token)
      if (this.$store.state.Auth.user || this.$store.state.Auth.token) return true
      return false
    }
  },
  watch: {
    $route (to, from) {
      this.pageName = null
    }
  },
  created () {
    this.initLocale().then((changed) => {
      this.show = true
      if (changed) this.key = Date.now()
    })
  },
  mounted () {
    this.$root.$on('localeChanged', () => {
      this.key = Date.now()
    })
  },
  methods: {
    setPageName (pageName) {
      this.pageName = pageName
    }
  }
}
</script>

<style>
</style>
